module.exports = "/_next/static/images/nz-30299530bf0b71a2fb4ccc92e4c78693.svg";